<template>
  <figure @mouseleave="isZoom = false" @mousemove="zoom($event)" class="productZoomImage">
    <div
      :style="
        hasBg
          ? `background-image: url('${$helper.optimizeImageUrl(
              image,
              $device.isMobileOrTablet ? 'w_400,h_400' : 'w_750,h_750',
            )}')`
          : ''
      "
      @click="$emit('click')"
      class="productZoomImage__background zoom"
      ref="image"
    >
      <div :class="{ 'productZoomImage__image--hidden': isZoom }" class="productZoomImage__image">
        <new-image-box
          background-color="#fff"
          :alt="alt"
          :src="image"
          :width="500"
          :height="450"
          :image-params="$device.isMobileOrTablet ? 'w_400,h_400' : 'w_500,h_450'"
          center-image
          display-image
        />
      </div>
    </div>
  </figure>
</template>

<script>
import NewImageBox from '@/components/NewImageBox';

export default {
  name: 'ProductZoomImage',
  components: { NewImageBox },
  props: {
    alt: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hasBg: false,
      isZoom: false,
    };
  },
  methods: {
    zoom(e) {
      this.hasBg = true;
      const isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;

      if (!isTouch) {
        this.isZoom = true;
        const zoom = this.$refs.image;
        const offsetX = e.offsetX;
        const offsetY = e.offsetY;
        const x = (offsetX / e.currentTarget.offsetWidth) * 100;
        const y = (offsetY / e.currentTarget.offsetHeight) * 100;
        zoom.style.backgroundPosition = x + '% ' + y + '%';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.productZoomImage {
  display: inline-flex;
  max-width: 100%;

  @include rwd('tablet') {
    padding: 0;
  }

  &__background {
    background-repeat: no-repeat;
  }

  &__image {
    transition: opacity 0.5s;
    background-color: $cWhite;
    max-width: 100%;

    &--hidden {
      opacity: 0;
    }
  }

  background-position: 50% 50%;
  position: relative;
  overflow: hidden;
  cursor: zoom-in;
}
</style>
